import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayConfigurationEndpointService {
    constructor (store) {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/configuration/`
        this.webApi = new WebApi(store)
            .readSuccess('Операция успешно проведена!')
            .readError('Операция проведена с ошибкой!')
    }

    async copyConf (configurationId) {
        const configuration = await this.webApi.get(`${this.url}copy/${configurationId}`)
        console.log('copy configuration:', configuration)
        if (configuration) {
            if (!configuration.status_code) {
                if (!configuration.error) {
                    return configuration
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${configuration.status_code}`)
            }
        }
        return null
    }

    async getList (filter) {
        const configuration = await this.webApi.post(`${this.url}list`, filter)
        console.log('configuration:', configuration)
        if (configuration) {
            if (!configuration.status_code) {
                if (!configuration.error) {
                    return configuration
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${configuration.status_code}`)
            }
        }
        return null
    }
}
